/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiMasterTrustedCompanyContentAddPost } from '../fn/trusted-company-content/api-master-trusted-company-content-add-post';
import { ApiMasterTrustedCompanyContentAddPost$Params } from '../fn/trusted-company-content/api-master-trusted-company-content-add-post';
import { apiMasterTrustedCompanyContentDeleteGet } from '../fn/trusted-company-content/api-master-trusted-company-content-delete-get';
import { ApiMasterTrustedCompanyContentDeleteGet$Params } from '../fn/trusted-company-content/api-master-trusted-company-content-delete-get';
import { apiMasterTrustedCompanyContentEditPost } from '../fn/trusted-company-content/api-master-trusted-company-content-edit-post';
import { ApiMasterTrustedCompanyContentEditPost$Params } from '../fn/trusted-company-content/api-master-trusted-company-content-edit-post';
import { apiMasterTrustedCompanyContentGetActiveGet } from '../fn/trusted-company-content/api-master-trusted-company-content-get-active-get';
import { ApiMasterTrustedCompanyContentGetActiveGet$Params } from '../fn/trusted-company-content/api-master-trusted-company-content-get-active-get';
import { apiMasterTrustedCompanyContentGetAllGet } from '../fn/trusted-company-content/api-master-trusted-company-content-get-all-get';
import { ApiMasterTrustedCompanyContentGetAllGet$Params } from '../fn/trusted-company-content/api-master-trusted-company-content-get-all-get';
import { apiMasterTrustedCompanyContentGetByCriteriaPost } from '../fn/trusted-company-content/api-master-trusted-company-content-get-by-criteria-post';
import { ApiMasterTrustedCompanyContentGetByCriteriaPost$Params } from '../fn/trusted-company-content/api-master-trusted-company-content-get-by-criteria-post';
import { StringApiRespModel } from '../models/string-api-resp-model';
import { TrustedCompanyContent } from '../models/trusted-company-content';
import { TrustedCompanyContentApiRespModel } from '../models/trusted-company-content-api-resp-model';

@Injectable({ providedIn: 'root' })
export class TrustedCompanyContentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiMasterTrustedCompanyContentAddPost()` */
  static readonly ApiMasterTrustedCompanyContentAddPostPath = '/api/Master/TrustedCompanyContent/Add';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterTrustedCompanyContentAddPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterTrustedCompanyContentAddPost$Response(params?: ApiMasterTrustedCompanyContentAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<TrustedCompanyContentApiRespModel>> {
    return apiMasterTrustedCompanyContentAddPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterTrustedCompanyContentAddPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterTrustedCompanyContentAddPost(params?: ApiMasterTrustedCompanyContentAddPost$Params, context?: HttpContext): Observable<TrustedCompanyContentApiRespModel> {
    return this.apiMasterTrustedCompanyContentAddPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<TrustedCompanyContentApiRespModel>): TrustedCompanyContentApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterTrustedCompanyContentEditPost()` */
  static readonly ApiMasterTrustedCompanyContentEditPostPath = '/api/Master/TrustedCompanyContent/Edit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterTrustedCompanyContentEditPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterTrustedCompanyContentEditPost$Response(params?: ApiMasterTrustedCompanyContentEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<TrustedCompanyContentApiRespModel>> {
    return apiMasterTrustedCompanyContentEditPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterTrustedCompanyContentEditPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterTrustedCompanyContentEditPost(params?: ApiMasterTrustedCompanyContentEditPost$Params, context?: HttpContext): Observable<TrustedCompanyContentApiRespModel> {
    return this.apiMasterTrustedCompanyContentEditPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<TrustedCompanyContentApiRespModel>): TrustedCompanyContentApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterTrustedCompanyContentDeleteGet()` */
  static readonly ApiMasterTrustedCompanyContentDeleteGetPath = '/api/Master/TrustedCompanyContent/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterTrustedCompanyContentDeleteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTrustedCompanyContentDeleteGet$Response(params?: ApiMasterTrustedCompanyContentDeleteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<StringApiRespModel>> {
    return apiMasterTrustedCompanyContentDeleteGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterTrustedCompanyContentDeleteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTrustedCompanyContentDeleteGet(params?: ApiMasterTrustedCompanyContentDeleteGet$Params, context?: HttpContext): Observable<StringApiRespModel> {
    return this.apiMasterTrustedCompanyContentDeleteGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringApiRespModel>): StringApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterTrustedCompanyContentGetAllGet()` */
  static readonly ApiMasterTrustedCompanyContentGetAllGetPath = '/api/Master/TrustedCompanyContent/GetAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterTrustedCompanyContentGetAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTrustedCompanyContentGetAllGet$Response(params?: ApiMasterTrustedCompanyContentGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TrustedCompanyContent>>> {
    return apiMasterTrustedCompanyContentGetAllGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterTrustedCompanyContentGetAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTrustedCompanyContentGetAllGet(params?: ApiMasterTrustedCompanyContentGetAllGet$Params, context?: HttpContext): Observable<Array<TrustedCompanyContent>> {
    return this.apiMasterTrustedCompanyContentGetAllGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TrustedCompanyContent>>): Array<TrustedCompanyContent> => r.body)
    );
  }

  /** Path part for operation `apiMasterTrustedCompanyContentGetActiveGet()` */
  static readonly ApiMasterTrustedCompanyContentGetActiveGetPath = '/api/Master/TrustedCompanyContent/GetActive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterTrustedCompanyContentGetActiveGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTrustedCompanyContentGetActiveGet$Response(params?: ApiMasterTrustedCompanyContentGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TrustedCompanyContent>>> {
    return apiMasterTrustedCompanyContentGetActiveGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterTrustedCompanyContentGetActiveGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTrustedCompanyContentGetActiveGet(params?: ApiMasterTrustedCompanyContentGetActiveGet$Params, context?: HttpContext): Observable<Array<TrustedCompanyContent>> {
    return this.apiMasterTrustedCompanyContentGetActiveGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TrustedCompanyContent>>): Array<TrustedCompanyContent> => r.body)
    );
  }

  /** Path part for operation `apiMasterTrustedCompanyContentGetByCriteriaPost()` */
  static readonly ApiMasterTrustedCompanyContentGetByCriteriaPostPath = '/api/Master/TrustedCompanyContent/GetByCriteria';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterTrustedCompanyContentGetByCriteriaPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterTrustedCompanyContentGetByCriteriaPost$Response(params?: ApiMasterTrustedCompanyContentGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TrustedCompanyContent>>> {
    return apiMasterTrustedCompanyContentGetByCriteriaPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterTrustedCompanyContentGetByCriteriaPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterTrustedCompanyContentGetByCriteriaPost(params?: ApiMasterTrustedCompanyContentGetByCriteriaPost$Params, context?: HttpContext): Observable<Array<TrustedCompanyContent>> {
    return this.apiMasterTrustedCompanyContentGetByCriteriaPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TrustedCompanyContent>>): Array<TrustedCompanyContent> => r.body)
    );
  }

}
